import React from 'react';
import { Flex, LinkV1, TextV1 } from '@withjoy/joykit';
import { ReactComponent as ForwardChevron } from '@assets/icons/forward-chevron.svg';

export interface SidebarNavMobileCategoryProps
  extends Readonly<{
    handleOnClick: () => void;
    title: string;
    isBoldFont?: boolean | false;
    showChevron?: boolean | true;
  }> {}

export const SidebarNavMobileCategory: React.FC<SidebarNavMobileCategoryProps> = ({ handleOnClick, title, isBoldFont, showChevron }) => (
  <LinkV1 onClick={handleOnClick} underline="none">
    <Flex justifyContent="space-between" alignItems="center" marginBottom="28px">
      <TextV1 component="h1" fontWeight={isBoldFont ? 'bold' : 'regular'} variant="body1">
        {title}
      </TextV1>
      {showChevron && <ForwardChevron />}
    </Flex>
  </LinkV1>
);

SidebarNavMobileCategory.displayName = 'SidebarNavMobileCategory';
